import { postRequest } from '@/config/network'
import { getDsjDomain } from '@/config/utils'
import productMask from '@/components/productMask'

export const OPERATION_TYPES = {
  '点击': 0,
  '光标进入': 5,
  '光标离开': 6,
  '曝光': 9,
  '自动跳转': 10
}

export const BUTTON_IDS = {
  // '额度更新-同意协议': 'agree_protocol',
  // '额度更新-马上更新': 'update_now',
  '首页先享后付-弹窗提交': 'define',
  'banner先享后付-弹窗提交': 'define',
  '申请借款页面先享后付-弹窗提交': 'define',
  '申请成功页面先享后付-弹窗提交': 'define',
  '借款结果页先享后付配置-确定': 'syqy',
  '借款结果页先享后付挽留弹窗-立即提现': 'withdraw',
  '锡锡贷借款结果页-会员开通': 'banner',
  '锡锡贷先享后付配置-确定': 'define',
  '锡锡贷先享后付挽留弹窗-立即提现': 'withdraw',
  '锡锡贷借款先享后付签约页面-弹窗提交': 'define',
  '锡锡贷先享后付签约页面-弹窗提交': 'define',
  '天创联登-立即申请': 'borrow_now',
  '多笔未还账单-立即还款': 'repayment_now',
  '车抵贷-立即申请': 'apply_now',
  '智选借款审核中弹窗-不感兴趣': 'no_interest',
  '智选借款审核中弹窗-弹窗跳转': 'jump',
  '智选借款审核中Banner-banner跳转': 'jump',
  '福利日-限时提额立即使用': 'syte',
  '福利日ocr弹窗-去授信': 'dj_nocr',
  '福利日-加速审批': 'jssp',
  '福利日-限时提额': 'xsfl',
  '福利日-借款福利': 'jkfl',
  '福利日-新人福利': 'xrfl',
  '福利日-幸运红包': 'xyhb',
  '福利日-66红包': 'llhb',
  '福利日-查看权益': 'flr_ckqy',
  '申请借款页-会员banner': 'member_banner',
  '申请借款页-弹窗banner': 'borrow_dialog',
  '申请借款页-去借钱按钮': 'borrow_now',
  '申请借款页-勾选协议': 'check_protocol',
  '申请借款页-强制阅读弹窗同意按钮': 'agree_protocol',
  '申请借款页-强制阅读弹窗关闭': 'close_protocol',
  '借款确认页-返回': 'back',
  '借款确认页-确认按钮': 'confirm',
  '借款确认页-借款验证码弹窗确认按钮': 'borrow_sms_confirm',
  '安全认证页-法大大三方认证页面': 'fdd_auth',
  '安全认证页-借款验证码弹窗确认按钮': 'borrow_sms_confirm',
  '新增银行卡-验证码弹窗确认按钮': 'sms_confirm',
  '借款结果页-banner': 'banner',
  'OCR-会员banner': 'member_banner',
  'OCR-新资源位banner': 'new_banner',
  'OCR-人像面': 'front',
  'OCR-国徽面': 'back',
  'OCR-勾选协议': 'check_protocol',
  'OCR-提交': 'submit',
  '智能匹配-显示': 'smart_match_show',
  '首页进入一推被拒页3-补充资料': 'bczl',
  '首页进入一推被拒页-补充资料': 'bczl',
  '一推被拒页-补充资料': 'bczl',
  // 还款相关
  '还款记录贷款详情页-查看合同弹窗联系客服': 'contact_service',
  '还款结果页-弹窗已结清': 'download_clear',
  '还款结果页-弹窗未结清': 'download_Unclear',
  '还款专用登录页-登录': 'login_btn',
  // 会员相关
  '开通会员弹窗-OCR暂不需要': 'ocr_no_need',
  '开通会员弹窗-OCR立即开通': 'ocr_now_open',
  '开通会员弹窗-借款申请暂不需要': 'borrow_no_need',
  '开通会员弹窗-借款申请立即开通': 'borrow_now_open',
  '会员订单提交页-立即开通续费': 'now_open',
  '会员Tab未开通会员-顶部图片资源位': 'top',
  '会员Tab未开通会员-底部图片资源位': 'bottom',
  '会员Tab未开通会员-优先审批': 'examine',
  '会员Tab未开通会员-专属通道': 'passway',
  '会员Tab未开通会员-专属提额': 'withdrawal',
  '会员Tab未开通会员-会员红包': 'redpacket',
  '会员Tab未开通会员-生活特权视频会员卡': 'life',
  '会员Tab未开通会员-立即解锁服务特权': 'service',
  '会员Tab已开通会员-顶部图片资源位': 'top',
  '会员Tab已开通会员-底部图片资源位': 'bottom',
  '会员Tab已开通会员-优先审批': 'examine',
  '会员Tab已开通会员-专属通道': 'passway',
  '会员Tab已开通会员-专属提额': 'withdrawal',
  '会员Tab已开通会员-会员红包': 'redpacket',
  '会员Tab已开通会员-生活特权视频会员卡': 'life',
  '会员Tab已开通会员-立即续费': 'now_renew',
  '会员开通结果页-马上提额': 'dj_mste',
  '会员开通结果页-马上提现': 'dj_mstx',
  'OCR前领取额度-马上领取额度': 'get_credit',
  'OCR前领取额度-免费通道': 'free_road',
  'OCR前领取额度-同意协议领取特权': 'dqk_submit',
  'OCR前领取额度-立即领取特权': 'get_credit_now',
  'OCR前领取额度-仍然选择免费通道': 'insist_free_passage',
  'OCR前领取额度-确定放弃': 'go_ocr',
  'OCR前领取额度-返回首页': 'ocr_back',
  // 邀请/注册/下载APP相关
  '金可花短信落地页-下载': 'download',
  '易花花半流程落地页-下载': 'download',
  '易花花短信落地页-下载': 'download',
  '微信模板消息落地页-下载': 'download',
  '邀请好友页-分享成功': 'share_success',
  '邀请好友页-分享领取': 'share_receive',
  '微信公众号落地页-下载': 'download',
  '微信服务号落地页-下载': 'download',
  'APP分享落地页-下载': 'download',
  '短信落地页-下载': 'download',
  '新短信落地页-下载': 'download',
  '短信小程序落地页-下载': 'download',
  '默认落地页-下载': 'download',
  '渠道注册页-提交注册': 'submit',
  '渠道注册页-icon': 'icon',
  '渠道注册页-下载': 'download',
  '易借好贷短信落地页-下载': 'download',
  '占位符': '',
  '借款失败页面-返回首页': 'back_to_home',
  '借款失败页面-同意协议立即购买': 'borrow_buy_pay_now',
  '申请借款页-易橙助贷卡弹窗': 'borrow_card_dialog',
  '申请借款页-立即支付按钮': 'borrow_card_pay_now',
  '申请借款页-弹窗关闭按钮': 'borrow_card_close',
  '申请借款页-查看更多权益': 'borrow_card_view_more',
  '申请借款页-易橙助贷卡按钮': 'borrow_card',
  '中原消金借款拦截页页面-24% >': 'xzlv',
  '中原消金借款拦截页页面-24%（推荐）': '24lv',
  '中原消金借款拦截页页面-35%': '35lv',
  '中原消金借款拦截页页面-放弃当前额度，重新审核': 'cxsh',
  '中原消金借款拦截页页面-保留当前额度': 'bldqed',
  '中原消金借款拦截页页面-重新审核（5S）': 'cxsh2',
  '中原消金借款拦截页页面-查看金尊卡权益': 'ckqy',
  '杭金投借款拦截页页面-查看金尊卡权益': 'ckqy',
  '长银消金借款拦截页页面-查看金尊卡权益': 'ckqy',
  '蓝海银行智选借款首页-激活额度': 'jhed',
  '蓝海银行智选借款首页-提升额度': 'tsed',
  '蓝海银行智选借款授信页-提交': 'jhed',
  '蓝海银行智选借款首页-去提现': 'borrow',
  '蓝海银行申请借款页-开通会员': 'kthy',
  '蓝海银行申请借款页-确认借款': 'borrow',
  '蓝海银行借款结果页-再借一笔': 'borrow',
  '蓝海银行借款结果页-开通会员banner': 'kthy',
  '半流程广告提现页-下载按钮': 'borrow',
  '老客福利社下载落地页-进入下载页面': 'exposure_lkfls_download',
  '老客福利社下载落地页-点击下载按钮': 'click_lkfls_download',
  '一推审核-同意协议按钮': 'click_ytsh',
  '一推审核-取消协议': 'reject_protocol',
  '一推审核-法大大三方认证页面': 'fdd_auth',
  '提额中心-活动弹窗': 'tezx_hdtc',
  '提额中心-周周打卡试试手气': 'member-sssq',
  '提额中心-个税提额': 'gs',
  '提额中心-车辆提额': 'cl',
  '提额中心-会员提额': 'hy',
  '提额中心-机构提额': 'jg',
  '提额中心-增信提额': 'fxbg',
  '订单详情-售后按钮': 'after_sale',
  '退款发起-领取权益，并取消退款': 'cancel_refund',
  '退款发起-继续申请，放弃金尊卡': 'go_ahead',
  '问卷信息填写-提交申请': 'submit_apply',
  '二次退款发起-领取权益，并取消退款': 'qx_refund',
  '二次退款发起-继续申请，放弃金尊卡': 'jxsq',
  '二次退款发起-专属提额': 'zste',
  '退款确认-我再想想': 'think_again',
  '退款确认-确认退款': 'confirm_refund',
  '京东金融首页-去借钱': 'borrow',
  '我的权益包-利息折扣券"立即激活"按钮': 'activate_now2',
  '智选借款半流程产品列表页-立即提现': 'tx',
  '智选借款授信页-法大大三方认证页面': 'fdd_auth',
  // 智选借款权益
  '智选借款授信页权益-勾选权益': 'define',
  '智选借款提交页-返回': 'return',
  '智选借款提交页-放弃': 'abandon',
  '智选借款提交页挽留弹窗-放弃': 'abandon',
  '智选借款提交页挽留弹窗-同意': 'agree',
  '智选借款权益-勾选权益': 'check',
  '智选借款权益-去详情页': 'watchDetail',
  '智选借款权益挽留弹窗-同意': 'agree',
  '智选借款权益挽留弹窗-放弃': 'abandon',
  '智选借款半流程产品列表页-提交': 'zxjk_list_ljtx',
  '机构产品协议页-提交': 'jg_submit',
  // 期货
  '期货三方-允许授权': 'allow',
  '期货三方-联登': 'third_login',
  // 速牛
  '速牛短信登录模块-登录': 'login',
  '速牛短信首页模块-点击借款': 'borrow_now',
  '速牛短信下载页-下载': 'click',
  // 其他
  '我的客服-在线客服': 'online_service',
  '我的客服-拨打': 'dial'
}

export const PAGE_IDS = {
  // '额度更新': 'edgx',
  '首页先享后付': 'xxhf_home',
  'banner先享后付': 'xxhf_banner',
  '申请借款页面先享后付': 'xxhf_submit',
  '申请成功页面先享后付': 'xxhf_submit_suc',
  '借款结果页先享后付配置': 'xxhf_submit_qytc',
  '借款结果页先享后付挽留弹窗': 'xxhf_submit_qytc_wl_popup',
  '锡锡贷提交中页面': 'xxd_jksq_loading',
  '锡锡贷借款结果页': 'xxd_jksq_success',
  '锡锡贷先享后付配置': 'member_adv',
  '锡锡贷先享后付挽留弹窗': 'wl_popup',
  '锡锡贷借款先享后付签约页面': 'xxdborrow_xxhf_sign',
  '锡锡贷先享后付签约页面': 'xxd_xxhf_sign',
  '天创联登': 'join_login',
  '多笔未还账单': 'bill_record_multiple',
  '车抵贷': 'card_loan',
  '智选借款审核中弹窗': 'borrow_adv_result_credit_dialog',
  '智选借款审核中Banner': 'borrow_adv_result_credit_banner',
  // '借款人信息': 'borrow_person_info',
  '测试榕树借款协议': 'test_protocol_rs_loan',
  '测试榕树强制借款协议': 'test_protocol_rs_loanForce',
  '测试征信三合一协议': 'test_protocol_xs_personMultiple',
  '测试关注官方企业微信页': 'test_wechatpage',
  '测试易借平台用户授权协议': 'test_protocol_queryaccredit',
  '测试树洞首页': 'test_shudong_index',
  '测试树洞登录页': 'test_shudong_login',
  // 还款相关
  '还款专用登录页': 'h5Repay_login',
  '还款专用登录成功页': 'h5Repay_login_success',

  '福利日落地页': 'flr_download',
  '福利日': 'flr_bg',
  '福利日ocr弹窗': 'flr_nocr',
  '精选贷超': 'loan_market',
  '智能匹配': 'smart_match',
  '新广告H5列表': 'new_loan_market',
  '额度激活失败': 'edjhsb',
  // 被拒页
  '首页进入一推被拒页': 'apphome_first_push_fail',
  '首页进入一推被拒页3': 'apphome_first_push_fail3',
  '一推被拒页': 'first_push_fail',
  '首页进入一推被拒页返回弹窗': 'apphome_first_push_fail_back_dialog',
  '首页进入一推被拒页返回弹窗3': 'apphome_first_push_fail_back_dialog3',
  '一推被拒页返回弹窗': 'first_push_fail_back_dialog',
  '申请借款页': 'apply_borrow_page',
  '借款确认页': 'borrow_confirm_page',
  '安全认证页': 'safe_auth_page',
  '新增银行卡': 'add_bank_card',
  '借款结果页': 'borrow_result_page',
  '还款记录贷款详情页': 'repayment_record_detail_page',
  '还款结果页': 'repayment_result_page',
  // '借款提交页锡锡贷': 'borrow_result_page2',
  'OCR': 'identity_card',
  // 会员相关
  '开通会员弹窗': 'member_dialog',
  '会员订单提交页': 'member_order_submit',
  '会员订单提交页tabbar': 'member_order_submit_tabbar',
  '会员Tab未开通会员': 'member_not_open',
  '会员Tab已开通会员': 'member_open',
  'OCR前领取额度': 'ocr_dqk',
  '会员开通结果页': 'member_order_result',
  // 邀请/注册/下载APP相关
  '金可花短信落地页': 'jkh_sms_download',
  '易花花半流程落地页': 'yhh_blc_download',
  '易花花短信落地页': 'yhh_sms_download',
  '微信模板消息落地页': 'lzyj_wxgzh_template_download',
  '邀请好友页': 'invite',
  '邀请注册页': 'invite_register',
  '微信公众号落地页': 'lzyj_wxgzh_download',
  '微信服务号落地页': 'lzyj_wxfwh_download',
  'APP分享落地页': 'lzyj_share_download',
  '短信落地页': 'lzyj_duanxin_download',
  '新短信落地页': 'lzyj_sms_download',
  '短信小程序落地页': 'lzyj_sms_minprogram_download',
  '默认落地页': 'lzyj_download',
  '渠道注册页': 'channel_register',
  '易借好贷短信落地页': 'yjhd_duanxin_download',
  '借款失败页面': 'borrow_fail_page',
  '长银消金借款拦截页页面': 'zdkbg_cyxj',
  '杭金投借款拦截页页面': 'zdkbg_hjt',
  '中原消金借款拦截页页面': 'zdkbg_zyxj',
  '蓝海银行智选借款首页': 'zxjk',
  '蓝海银行智选借款授信页': 'zxjk_jhed',
  '智选借款授信页': 'zxjk_jhed',
  '蓝海银行申请借款页': 'zxjktx',
  '蓝海银行借款结果页': 'zxjktxjq',
  '半流程渠道下载页老版本': 'lblc_download',
  '半流程渠道下载页新版本': 'xblc_download',
  '半流程广告提现页': 'blctxy',
  '老客福利社下载落地页': 'lkfls',
  '一推审核': 'ytsh',
  '提额中心': 'tezx',
  '订单详情': 'order_details',
  '退款发起': 'request_refund',
  '问卷信息填写': 'refund_Info',
  '二次退款发起': 'refund_submit',
  '退款确认': 'refund_details',
  '京东金融首页': 'home_h5',
  '我的权益包': 'mine',
  '智选借款半流程产品列表页': 'zxjk_blc_product_list',
  '机构产品协议页': 'zxjk_jg_product_protocol',
  // 智选借款权益
  '智选借款授信页权益': 'zxjk_jksq_loading',
  '智选借款提交页': 'zxjk_jksq_success',
  '智选借款提交页挽留弹窗': 'zxjk_wl_popup',
  '智选借款权益': 'zxjk_rights',
  '智选借款权益挽留弹窗': 'zxjk_rights_leave_dialog',
  // 速牛
  '速牛短信登录模块': 'sn_login',
  '速牛短信首页模块': 'sn_money_home',
  '速牛短信审核模块': 'sn_money_loading',
  '速牛短信下载页': 'sn_download',
  // 期货
  '期货三方': 'qh_third',
  // 其他
  '我的客服': 'my_service_page'
}

export const getParams = type => {
  const [page, operate, button] = type.split('-')
  const buttonType = `${page}-${button}`
  const PAGE_ID = PAGE_IDS[page]
  const OPERATION_TYPE = OPERATION_TYPES[operate]
  const BUTTON_ID = (OPERATION_TYPE === 9 || button === '占位符') ? '' : BUTTON_IDS[buttonType]
  if (!PAGE_ID || BUTTON_ID === undefined || OPERATION_TYPE === undefined) {
    !PAGE_ID && console.warn(`'${page}'在PAGE_IDS配置中没有找到，请配置`)
    OPERATION_TYPE === undefined && console.warn(`'${operate}'在OPERATE_TYPES配置中没有找到，请配置`)
    BUTTON_ID === undefined && console.warn(`'${buttonType}'在BUTTON_IDS配置中没有找到，请配置`)
    return false
  }
  return {
    testName: `${operate} ${button || ''}`, PAGE_ID, BUTTON_ID, OPERATION_TYPE
  }
}

export const createMask = (Vue) => {
  return new Promise(resolve => {
    const parent = document.querySelector('#app')
    const ProductMask = Vue.extend(productMask)
    const install = new ProductMask({
      el: document.createElement('div'),
      data: {
        isShow: true
      }
    })
    parent.appendChild(install.$el)
    const timeout = setTimeout(() => {
      if (timeout) clearTimeout(timeout)
      install.isShow = false
      resolve()
    }, 3000)
  })
}

const dsjDomain = getDsjDomain()
export const apiBehaviorLog = (params, Package) => {
  return postRequest(`${dsjDomain}/common/log/behaviorLog`, {
    data: params, platform: 'yijie', package: Package
  })
}
